export default __webpack_public_path__ + "static/media/gtb.26466802.png";